<template>
  <footer class="offcanvas-wrapper site-footer cleat-pd" id="okubuy-footer" style="z-index: 3">
    <div class="container cleat-pd " id="container-if">
      <div class="row mr-0 ml-0" v-if="isMobile">
        <div class="col-12 footer-top pl-0 pr-0">
          <!-- About Us-->
            <ul>
              <li  class="pt-15">
                <router-link :to="{ name: 'faq' }"><p><i class="el-icon-warning"></i></p> <span>{{ $t('footer.faq') }}</span> </router-link>
              </li>
              <span class="interval"></span>
              <li  class="pt-15">
                <router-link :to="{ name: 'contacts' }"><p><i class="el-icon-question"></i></p><span>{{ $t('footer.contacts') }}</span> </router-link>
              </li>
              <!--<li>-->
              <!--<router-link :to="{ name: 'delivery-schedule' }"> {{ $t('footer.delivery') }} </router-link>-->
              <!--</li>-->
              <span class="interval"></span>
              <li  class="pt-15">
                <router-link :to="{ name: 'guide' }"><p><i class="el-icon-tickets"></i></p><span>{{ $t('topbar.guide') }} </span> </router-link>
              </li>
            </ul>
          <hr class="hr-light ">
        </div>
        <el-collapse class="col-lg-3 row-borader pl-30 pr-30" v-model="activeName" accordion>
          <el-collapse-item class="footerEmail widget-links widget-light-skin">
            <template slot="title">
              <span class="font-style">{{ $t('footer.information') }}</span>
            </template>
            <hr class="hr-light margin-bottom-1x">
            <div><ul>
              <li>
                <a @click="routerTo('news')"> {{ $t('footer.news') }} </a>
              </li>
              <li>
                <a @click="routerTo('terms-and-conditions')"> {{ $t('footer.terms_and_conditions') }}
                </a>
              </li>
              <li>
                <a @click="routerTo('privacy-policy')"> {{ $t('footer.privacy_policy') }} </a>
              </li>
              <li>
                <a @click="routerTo('delivery_schedule')"> {{ $t('footer.delivery') }} </a>
              </li>
            </ul></div>
          </el-collapse-item>
          <hr class="hr-light">
          <el-collapse-item class="footerEmail widget-links widget-light-skin">
            <template slot="title">
              <span class="font-style">{{ $t('user.user_center') }}</span>
            </template>
            <hr class="hr-light margin-bottom-1x">
            <div><ul>
              <li>
                <a @click="routerTo('orders')" > {{ $t('user.my_orders') }} </a>
              </li>
              <li>
                <a @click="routerTo('shipping-address')"> {{ $t('user.shipping_address') }} </a>
              </li>
              <li>
                <a @click="routerTo('wishlist')"> {{ $t('user.wish_list') }} </a>
              </li>
              <li>
                <a @click="routerTo('information')"> {{ $t('user.information') }} </a>
              </li>
            </ul></div>
          </el-collapse-item>
          <hr class="hr-light">
          <el-collapse-item class="footerEmail widget-light-skin">
          <template slot="title" >
            <span class="font-style">{{ $t('footer.contact_us') }}</span>
          </template>
          <hr class="hr-light mt-2 margin-bottom-1x">
          <div> <p class="text-white" v-if="config.phone">{{ $t('footer.phone') }}:
            <a class="navi-link-light" id="strong" href="callto:852-3956 8268">
              <span style="font-weight: 500">{{ config.phone }}</span>
            </a>
          </p></div>
          <div> <ul class="list-unstyled text-sm text-white">
            <li><span class="opacity-50">{{ $t('footer.monday_friday') }}:</span>9.00 am - 8.00 pm</li>
          </ul></div>
          <div><p v-if="config.help_mail">
            <a class="navi-link-light" :href="config.help_mail">{{ config.help_mail }}</a>
          </p></div>
        </el-collapse-item>
        </el-collapse>
      </div>
      <div class="row" v-if="!isMobile">
        <div class="col-lg-3">
          <!-- Contact Info-->
          <section class="widget widget-light-skin">
            <h3 class="widget-title">{{ $t('footer.contact_us') }}</h3>
            <p class="text-white" v-if="config.phone">{{ $t('footer.phone') }}:
              <a class="navi-link-light" href="callto:852-3956 8268">
                <span style="font-weight: 500">{{ config.phone }}</span>
              </a>
            </p>

            <ul class="list-unstyled text-sm text-white">
              <li><span>{{ $t('footer.monday_friday') }}: </span> <span style="font-weight: 500">9.00 am - 8.00 pm</span></li>
            </ul>
            <p v-if="config.help_mail">
              <a class="navi-link-light" :href="config.help_mail" style="font-weight: 500">{{ config.help_mail }}</a>
            </p>
            <p class="text-white" style="white-space: pre-line;">{{ config.company_address }}</p>
          </section>
        </div>
        <div class="col-lg-3">
          <!-- About Us-->
          <section class="widget widget-links widget-light-skin">
            <h3 class="widget-title">{{ $t('footer.customer_service') }}</h3>
            <ul>
              <li>
                <router-link :to="{ name: 'faq' }"> {{ $t('footer.faq') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'contacts' }"> {{ $t('footer.contacts') }} </router-link>
              </li>
              <!--<li>-->
              <!--<router-link :to="{ name: 'delivery-schedule' }"> {{ $t('footer.delivery') }} </router-link>-->
              <!--</li>-->
              <li>
                <router-link :to="{ name: 'guide' }"> {{ $t('topbar.guide') }} </router-link>
              </li>
            </ul>
          </section>
        </div>
        <div class="col-lg-3">
          <!-- Account / Shipping Info-->
          <section class="widget widget-links widget-light-skin">
            <h3 class="widget-title">{{ $t('footer.information') }}</h3>
            <ul>
              <li>
                <router-link :to="{ name: 'news' }"> {{ $t('footer.news') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'terms-and-conditions' }"> {{ $t('footer.terms_and_conditions') }}
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'privacy-policy' }"> {{ $t('footer.privacy_policy') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'about-us' }"> {{ $t('footer.about_us') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'delivery_schedule' }"> {{ $t('footer.delivery') }} </router-link>
              </li>
            </ul>
          </section>
        </div>
        <div class="col-lg-3">
          <!-- Account / Shipping Info-->
          <section class="widget widget-links widget-light-skin">
            <h3 class="widget-title">{{ $t('user.user_center') }}</h3>
            <ul>
              <li>
                <router-link :to="{ name: 'orders' }"> {{ $t('user.my_orders') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'shipping-address' }"> {{ $t('user.shipping_address') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'wishlist' }"> {{ $t('user.wish_list') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'information' }"> {{ $t('user.information') }} </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'proxy-request' }">
                  {{ $t('nav.proxy_request') }}
                </router-link>
              </li>
            </ul>
          </section>
        </div>
      </div>
      <hr class="hr-light mt-2 margin-bottom-1x">
      <div class="row ml-0 mr-0">
        <div class="col-md-7 padding-bottom-1x">
          <!-- Payment Methods-->
          <div class="margin-bottom-1x" style="max-width: 615px;">
            <!--
            <img src="//www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppppcmcvdam.png"
                 alt="Pay with PayPal, PayPal Credit or any major credit card">
             -->
            <img src="../../assets/payments/fps.jpg" alt="fps" style="height: 40px;margin: 0 5px;" />
            <img src="../../assets/payments/wechat.png" alt="Wechat Pay" style="width: 70px;height: 40px;margin: 0 5px;">
            <img src="../../assets/payments/ali.jpg" alt="Ali Pay" style="width: 70px;height: 40px;">
          </div>
        </div>
        <!--
        <div class="col-md-5 padding-bottom-1x">
            <div class="margin-top-1x hidden-md-up"></div>-->
        <!--Subscription-->
        <!-- <el-form class="subscribe-form" :model="requestForm" :rules="rules" ref="rules">
             <div class="clearfix">
                 <div class="input-group input-light ">
                     <el-form-item prop="email" class="form-control footerEmail">
                         <el-input v-model="requestForm.email"
                                 :placeholder="$t('register.placeholder.email')" />
                     </el-form-item>
                     <div class="input-group-prepend">
                       <span class="input-group-addon"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                     </div>
                 </div>
                 <button class="btn btn-primary" type="button" :title="$t('footer.subscription')" @click="subscription">
                     <i class="fa fa-check" aria-hidden="true"></i>
                 </button>
             </div><span class="form-text text-sm text-white opacity-50">{{ $t('footer.subscribe') }}</span>
         </el-form>
     </div>
     -->
      </div>
      <!-- Copyright-->
      <div class="footer-copyright">
        <div class="pull-left text-hidden" :style="isMobile ? 'width: 100%' : ''">
          {{ config.copyright }}
        </div>
        <div class="pull-right" v-if="config.icp && !isMobile">
          ICP：<a href="http://beian.miit.gov.cn" target="_blank">{{ config.icp }}</a>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'SiteFooter',
    data() {
      return {
        activeName: '',
        requestForm: {
          email: '',
        },
        rules: {
          email: [
            { required: true, message: this.$t('register.rules_message.email_required'), trigger: 'blur' },
            { type: 'email', message: this.$t('register.rules_message.email_type'), trigger: ['blur', 'change'] },
          ],
        },
      };
    },
    computed: {
      ...mapState({
        config: state => state.config,
      }),
      ...mapGetters([
        'isMobile',
      ]),
    },
    methods: {
      routerTo(data) {
        this.$router.push({ name: data });
        // setTimeout(window.location.reload(), 2000);
      },
      subscription() {
        this.$refs.rules.validate((valid) => {
          if (valid) {
            this.$router.push({ name: 'register', query: { email: this.requestForm.email } });
          }
        });
      },
    },
  };
</script>

<style lang="scss">

  @import "../../styles/helpers/variables";

  //
  // Footer
  // --------------------------------------------------

  .site-footer {
    padding-top: floor($grid-vertical-step * 2); //~48px;
    background-color: $gray-darker;
    @media (max-width: $screen-md) {
      padding-top: floor($grid-vertical-step / 2); //~12px;
    }
    .footerEmail {
      div {
        background-color: $gray-darker;
        border: none;
        color: $gray-lighter;
      }
      i {
        color: $gray;
      }
    }
  }
  .text-hidden {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
  .footer-copyright {
    margin: 0;
    padding: {
      top: 10px;
      bottom: $grid-vertical-step; // ~24px
    }
    color: rgba($white-color, .5);
    font: {
      size: $font-size-sm;
      weight: normal;
    }
    a {
      transition: color .25s;
      color: rgba($white-color, .5);
      text-decoration: none;
      &:hover {
        color: $link-hover-color;
      }
    }
  }

  // Light Footer
  .footer-light {
    background-color: $gray-lighter;
    .footer-copyright {
      color: $gray;
      > a {
        color: $gray;
        &:hover {
          color: $link-hover-color;
        }
      }
    }
  }

  #okubuy-footer {
    position: relative;
    z-index: 1;
    background-color: $gray-darker;
    .input-group > .form-control {
      width: 100%;
      border-radius: 22px;
    }
  }

  .row-borader {
    border: none !important;
  }

  .font-style {
    color: $gray;
    font-size: 14px;
    font-weight: $pagination-link-font-weight;
    padding-bottom: 0px;
  }

  .footer-md {
    margin-bottom: 10px !important;
  }

  .footer-hr {
    border-bottom: 1px solid $gray-light;
  }

  .footer-top {
    background-color: #aaa;
    ul {
      list-style: none;
      margin: 0px !important;
      padding: 0px !important;
      position: relative;
      li {
        width: 32%;
        display: inline-block;
        line-height: 2rem;
        a {
          display: block;
          text-align: center;
          transition: color .25s;
          color: $white-color;
          font-weight: 700;
          text-decoration: none;
          p {
            height: 42px;
            line-height: 38px;
            margin-bottom: 0px;
            font-size: 42px;
            color: $white-color;
            i {
              font-size: .85em;
            }
          }
        }
      }
      li:nth-child(3) {
        p {
          xpadding-top: 3p;
          i {
            font-size: 1em;
          }
        }
      }
    }
  }

  @media (max-width: $screen-sm) {
    .interval {
      height: 40%;
      border: 1px solid $white-color;
      border-radius: 1px;
      display: inline-block;
      width: 0px !important;
      position: absolute;
      bottom: 20px;
    }
    .cleat-pd {
      padding: 0px !important;
    }
  }
</style>
